<template>
  <vue-draggable-resizable
    :x="pos[0]" 
    :y="pos[1]" 
    :w="dims[0]" 
    :h="dims[1]" 
    :minWidth="minDims[0]" 
    :minHeight="minDims[1]"
    :maxWidth="maxDims[0]" 
    :maxHeight="maxDims[1]" 
    :active="true" 
    :handle="['tl', 'tr', 'br', 'bl']"
    drag-handle="#drag"
    >
    <div class="w-100 h-100">
      <div class="d-flex justify-content-between align-items-center window-header px-2 py-1" id="drag">
        <h5 class="window-title">{{ title }}</h5>
        <svg 
          @click="()=> $emit('close')"
          xmlns="http://www.w3.org/2000/svg" 
          width="16px" 
          height="16px"
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          stroke-width="2" 
          stroke-linecap="round"
          stroke-linejoin="round" 
          class="ml-1 cursor-pointer feather feather-x"
          >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </div>
      <div class="window-body">
        <slot></slot>
      </div>
    </div>

  </vue-draggable-resizable>
</template>

<script>


import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import VueDraggableResizable from 'vue-draggable-resizable'

export default {
  name: 'Window',
  components: {
    VueDraggableResizable
  },
  props: {
    title: {
      type: String,
      default: 'title'
    },
    pos:{
      type:Array,
      default: () => [0, 0]
    },
    dims: {
      type: Array,
      default: () => [300, 300]
    },
    minDims: {
      type: Array,
      default: () => [0, 0]
    },
    maxDims: {
      type: Array,
      default: () => [900, 900]
    }
  }
}
</script>

<style lang="scss">
.window-header {
  height: 20px !important;
  background-color:#f6f6f6;
}
.window-title{
  margin: 0px;
  width: 85% !important;
}
.window-body {
  height: calc( 100% - 28px) !important;
}
.handle {
  background-color: transparent !important;
  border-color: transparent !important;
}
.draggable {
  pointer-events: auto !important;
}
.resizable {
  pointer-events: auto !important;
}
.vdr {
  pointer-events: auto !important;
  border-color:dimgray !important;
  border-style: groove !important;
}
</style>
